// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"VideoBanner_videoWrapper__CUyFw","player":"VideoBanner_player__tIHr8","cover":"VideoBanner_cover__EFI28","coverHidden":"VideoBanner_coverHidden__zOn7Z"};